<template>
    <div>
        <div :id=uid class="modal">
            <div class="modal-content" v-html="questionrichtext" v-if="questionrichtext"/>
            <div class="modal-content" v-else>
                <slot>
                    {{question}}
                </slot>
            </div>
            <div class="modal-footer">
                <button class="modal-close btn-flat cancelbutton" v-on:click="cancelClicked()">{{cancelText}}</button>
                <button class="modal-close waves-effect waves-light btn-small" :class="confirmButtonClass" v-on:click="okClicked()">{{confirmText}}</button>
            </div>
        </div>
        <a v-if="showTrigger" class="waves-effect waves-light btn-small red modal-trigger"  :href="'#'+uid">{{confirmText}}</a>
    </div>
</template>
<script>
import axios from 'axios';
import _ from 'lodash';
export default {
    data: function() {
      return {
        uid: _.uniqueId(this.identifier),
        instances: []
      }
    },
    props: {
        question: String,
        confirmText: String,
        identifier: String,
        questionrichtext: String,
        cancelText: {
            type: String, default: "Anuluj"
        },
        showTrigger: {
            type: Boolean, default: true
        },
        confirmButtonClass: {
            type: String,
            default: 'red'
        }
    },
    mounted: function() {
      var elems = this.$el.querySelectorAll('.modal');
      this.instances = M.Modal.init(elems, {});
    },
    methods: {
      okClicked:function() {
        this.instances[0].close();
        this.$emit('onConfirm');
      },
      cancelClicked: function(){
        this.instances[0].close();
        this.$emit('onCancel');
      },
      open: function(){
        this.instances[0].open();
      }
    }
}
</script>
<style scoped>
.modal {
    position: absolute;
    margin-left: auto;
    line-height: 2;
}
.modal-content{
    text-align: start !important;
}
p{
    text-align: center;
}
.cancelbutton{
    border: 1px solid black;
    border-radius: 8px;
}
.btn-small{
    margin: 15px;
}
.modal-trigger{
    margin: initial;
}
</style>